<template>
  <div id="onlineExamPage"
       class="container-fluid has-action-bar has-footer">
    <ActionBar title="آزمون آنلاین"></ActionBar>
    <div class="row container mx-auto p-0 mt-2">
      <div class="col-9  col-md-6 col-lg-6 p-0 mb-4 mx-auto">
        <div class="member-ship-tab p-2 d-flex justify-space-between">
          <v-btn :class="{active: currentExams}" class="px-8 px-sm-12 px-lg-16" color="third" rounded
                 @click="showCurrentExams"><span class="font12px">جاری</span>
          </v-btn>
          <v-btn :class="{active: pastExams}" class="px-8 px-sm-12 px-lg-16" color="third" rounded
                 @click="showPastExams"><span class="font12px">گذشته</span>
          </v-btn>
          <!--          <v-btn :class="{active: examsRecords}" class="px-8 px-sm-12 px-lg-16" color="third" rounded-->
          <!--                 @click="showExamsRecords"><span class="font12px">سوابق</span>-->
          <!--          </v-btn>-->
        </div>
      </div>
    </div>
    <div v-if="currentExams">
      <div v-if="!hasCurrentExams" class="row container mx-auto p-0  mt-2">
        <div class="col-12">
          <v-alert
              border="bottom"
              class="mt-4 text-center"
              color="forth"
              dark>
            آزمونی وجود ندارد.
          </v-alert>
        </div>
      </div>
      <div v-else class="row container mx-auto p-0  mt-2">
        <div v-for="item in exams"
             :key="item.ExamID"
             class="col-12 col-sm-6 col-lg-4">
          <div class="row ">
            <div class="rounded-b-lg header-rounded  card-shadow  cursor-pointer col-12 "
                 @click="goToExamDetail(item.ExamID,item.Price,item.Minute,item.TimeEnd,
                 item.ExamEndDate,item.TimeStart,item.examStartTime,item.examEndTime,item.TypeTimeExam)">
              <div class="bg-white">
                <div class=" third-background header-rounded pt-1 text-center white--text">
                  {{ item.Name }}
                </div>
                <div class="row mx-1 ">
                  <div class="font12px col-12 pb-1 pt-3">
                    <span class="font-weight-bold font12px">زمان آزمون:</span> {{ (item.Minute) }} دقیقه
                  </div>
                  <div class="col-12 py-1">
                <span class="float-right font12px"><i class="fas fa-calendar-alt primary-text pl-2"></i><span
                    class="font-weight-bold font12px">تاریخ شروع:</span>{{ $convertDate(item.ExamStartDate) }}</span>
                    <span class="float-left font12px"><i class="fas fa-calendar-alt primary-text pl-2"></i><span
                        class="font-weight-bold font12px">تاریخ پایان:</span>{{ $convertDate(item.ExamEndDate) }}</span>
                  </div>
                  <div class="col-12  py-1">
            <span class="float-right font12px"><i class="fas fa-alarm-clock primary-text pl-2"></i><span
                class="font-weight-bold font12px">ساعت شروع:</span>{{ (item.TimeStart).slice(0, 5) }}</span>
                    <span class="float-left font12px"><i class="fas fa-alarm-clock primary-text pl-2"></i><span
                        class="font-weight-bold font12px">ساعت پایان:</span>{{ (item.TimeEnd).slice(0, 5) }}</span>
                  </div>
                  <div v-if="item.Price !== 0" class="font12px col-12 py-1 pb-3">
                  <span class="float-right font12px"><i class="fas fa-tags primary-text pl-2"></i><span
                      class="font-weight-bold font12px">قیمت:</span>{{ $numberWithCommas(item.Price) }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="pastExams">
      <div class="row container mx-auto p-0  mt-2">
        <div v-for="item in pastExamsArray"
             :key="item.ExamID"
             class="col-12 col-sm-6 col-lg-4  ">
          <div class="rounded-b-lg header-rounded  card-shadow  cursor-pointer col-12 "
               @click="seePastExamDetail(item.ExamID,item.Price)">
            <div class="bg-white">
              <div class=" third-background header-rounded pt-1 text-center white--text">
                {{ item.Name }}
              </div>
              <div class="row mx-1 ">
                <div class="font12px col-12 pb-0">
                  <span class="font-weight-bold font12px">زمان آزمون:</span> {{ (item.Minute) }} دقیقه

                </div>
                <div class="col-12 py-1">
                <span class="float-right font12px"><i class="fas fa-calendar-alt primary-text pl-2"></i><span
                    class="font-weight-bold font12px">تاریخ شروع:</span>{{ $convertDate(item.ExamStartDate) }}</span>
                  <span class="float-left font12px"><i class="fas fa-calendar-alt primary-text pl-2"></i><span
                      class="font-weight-bold font12px">تاریخ پایان:</span>{{ $convertDate(item.ExamEndDate) }}</span>
                </div>
                <div class="col-12  ">
            <span class="float-right font12px"><i class="fas fa-alarm-clock primary-text pl-2"></i><span
                class="font-weight-bold font12px">ساعت شروع:</span>{{ (item.TimeStart).slice(0, 5) }}</span>
                  <span class="float-left font12px"><i class="fas fa-alarm-clock primary-text pl-2"></i><span
                      class="font-weight-bold font12px">ساعت پایان:</span>{{ (item.TimeEnd).slice(0, 5) }}</span>
                </div>
                <div :class="item.Price !==0? true   :'visibility-hidden'" class="col-12">
                  <div><i class="fas fa-tags primary-text pl-2"></i><span
                      class="font-weight-bold font12px pl-1">قیمت:</span>{{ $numberWithCommas(item.Price) }} تومان
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--    <div v-if="examsRecords">
          <div v-if="!hasRecordExams" class="row container mx-auto p-0  mt-2">
            <div class="col-12">
              <v-alert
                  border="bottom"
                  class="mt-4 text-center"
                  color="forth"
                  dark>
                شما آزمونی شرکت نکرده اید.
              </v-alert>
            </div>
          </div>
          <div v-else class="row container mx-auto p-0  mt-2">
            <div v-for="item in examsRecord"
                 :key="item.ExamID"
                 class="col-12 col-sm-6 col-md-4 col-lg-3 ">
              <div class="bg-white rounded-b-lg header-rounded bg-white card-shadow pb-3"
                   @click="goToExamDetail(item.ExamID)">
                <div class=" third-background header-rounded pt-1 text-center white&#45;&#45;text">
                  {{ item.Name }}
                </div>
                <div class="font12px col-12 pb-0">
                  <span class="font-weight-bold font12px">زمان آزمون:</span> {{ (item.Minute) }} دقیقه
                  <span class="float-left font12px"> <i class="fal fa-calendar-alt primary-text"></i>
                {{ $convertDate(item.ExamDate) }}</span>
                </div>
                <div class="col-12 pb-5 ">
                <span class="float-right font12px"><i class="fas fa-alarm-clock primary-text pl-2"></i><span
                    class="font-weight-bold font12px">ساعت شروع:</span>{{ (item.TimeStart).slice(0, 5) }}</span>
                  <span class="float-left font12px"><i class="fas fa-alarm-clock primary-text pl-2"></i><span
                      class="font-weight-bold font12px">ساعت پایان:</span>{{ (item.TimeEnd).slice(0, 5) }}</span>
                </div>
                <div class="col-12">
                  <div v-if="item.Price !== 0"><i class="fas fa-tags primary-text pl-2"></i><span
                      class="font-weight-bold font12px pl-1">قیمت:</span>{{ $numberWithCommas(item.Price) }} تومان
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>-->
    <FooterMenu/>
    <v-dialog
        v-model="showLoaderDialog"
        hide-overlay
        persistent
        width="500">
      <v-card class="text-center py-5">
        <v-progress-circular
            color="primary"
            indeterminate
        ></v-progress-circular>
      </v-card>
    </v-dialog>
    <v-dialog
        v-model="showBuyExamDialog"
        persistent
        width="500">
      <v-card class="text-center pt-5">
        <v-card-text class="pb-0">
          <div class="mb-0 black--text">برای شرکت در این آزمون باید هزینه آن را پرداخت کنید</div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="pt-1 pb-3 justify-space-around">
          <v-btn class="px-8" color="forth" rounded @click="showBuyExamDialog = !showBuyExamDialog">
            <span class="white--text">بستن</span>
          </v-btn>
          <v-btn class="px-8" color="primary" rounded @click="buyExam">
            خرید
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
        v-model="showResultDialog"
        persistent
        width="500">
      <v-card class="text-center pt-5">
        <v-card-text class="pb-0">
          <div class="mb-0 black--text">{{ dialogResult }}</div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="pt-1 pb-3">
          <v-btn block class="primary" rounded @click="showResultDialog = !showResultDialog">
            بستن
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
        v-model="showGoToDialog"
        persistent
        width="500">
      <v-card class="text-center pt-5">
        <v-card-text class="pb-0">
          <div class="mb-0 black--text">مدت زمان این آزمون <span class="primary-text font-weight-bold">
            {{ examMin }}</span> دقیقه میباشد،در صورت ورود به آزمون زمان برای
            شما لحاظ خواهد شد و شما تا <span class="primary-text font-weight-bold"> {{ endExamTime }} </span> فرصت دارید
            پاسخنامه خود را ثبت کنید.
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="pt-1 pb-3 justify-space-around">
          <v-btn class="px-8" color="forth" rounded @click="showGoToDialog = !showGoToDialog">
            <span class="white--text">بستن</span>
          </v-btn>
          <v-btn class="px-8" color="primary" rounded @click="goToExam">
            شروع آزمون
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
let _this = null;
import ActionBar from "../components/ActionBar";
import FooterMenu from "../components/FooterMenu";

export default {
  name: "OnlineExam",
  metaInfo: {
    title: 'مسیربرتر-آزمون آنلاین'
  },
  components: {FooterMenu, ActionBar},
  data: () => ({
    currentExams: true,
    examsRecords: false,
    pastExams: false,
    hasCurrentExams: true,
    exams: [],
    pastExamsArray: [],
    examsRecord: [],
    showLoaderDialog: false,
    hasRecordExams: false,
    showBuyExamDialog: false,
    historyPay: [],
    examID: null,
    showResultDialog: false,
    showGoToDialog: false,
    dialogResult: null,
    examMin: null,
    endExamTime: null
  }),
  mounted() {
    _this = this;
    // this.$setExamData('','')
    this.getData();
    this.getExamsRecord();
    this.getPayHistory();
  },
  methods: {
    getData() {
      this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Authorization", _this.$getUserData().token);

      let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "ExamManagement/ListExam", requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)
            let now = new Date()
            json.sort((b, a) => a.ExamStartDate.localeCompare(b.ExamStartDate))
            for (let i = 0; i < json.length; i++) {
              json[i].examStartTime = json[i].ExamStartDate.slice(0, 11) + json[i].TimeStart
              json[i].examEndTime = json[i].ExamEndDate.slice(0, 11) + json[i].TimeEnd
            }
            let active = json.filter(x => x.IsActive === true)
            _this.pastExamsArray = active.filter(x => new Date(x.examEndTime) < now)
            _this.exams = active.filter(x => new Date(x.examEndTime) >= now)
            if (this.exams.length <= 0) {
              this.hasCurrentExams = false
            }
            _this.showLoaderDialog = false
          })
          .catch(error => console.log('error', error));
    },
    checkExamState(id, price, min, timeEnd, examDate, startTime, examStartTime, examEndTime, examType) {
      let currentDate = new Date();
      let examStartDate = new Date(examStartTime)

      let timeEndLocal = examEndTime.slice(0, 11) + timeEnd;

      let examHistoryData = this.$getExamData()

      let currentTime = currentDate.getHours() + ':' + currentDate.getMinutes()
      if (currentDate >= examStartDate) {
        let canEnterTime = new Date(examStartDate.setSeconds(examStartDate.getSeconds() + 5 * 60))

        if (examType === 2 && canEnterTime < currentDate) {
          this.dialogResult = 'زمان ورود به آزمون گذشته است'
          this.showResultDialog = true
        } else if (examHistoryData[id] !== undefined) {
          if (examHistoryData[id] >= currentTime) {
            this.$router.push({
              path: 'ExamDetail',
              query: {ExamID: this.examID, CanAnswer: 'true', currentExam: 'true'}
            })
          } else if (currentTime > timeEndLocal) {
            this.$router.push({
              path: 'ExamDetail',
              query: {ExamID: this.examID, CanAnswer: 'false', currentExam: 'true'}
            })
          } else {
            this.showResultDialog = true;
            this.dialogResult = 'مهلت شرکت در این آزمون گذشته است'
          }
        } else {
          this.showGoToDialog = true
        }
      } else if (currentDate < examStartDate) {
        this.showResultDialog = true;
        this.dialogResult = 'زمان شروع آزمون فرا نرسیده است'
      }
    },
    goToExamDetail(id, price, min, timeEnd, examDate, startTime, examStartTime, examEndTime, examType) {
      this.examID = id;
      this.examMin = min;
      //let currentDate = new Date();
      //let endTime = new Date(currentDate.setSeconds(currentDate.getSeconds() + min * 60))
      let endTime = new Date(examDate.slice(0, 11) + timeEnd);
      if (new Date(endTime.toISOString()) > new Date(examEndTime)) {
        this.endExamTime = timeEnd.slice(0, 5)
      } else {
        this.endExamTime = ((new Date(endTime.getTime())).toLocaleTimeString('en-GB')).slice(0, 5)
      }

      let payHistory = this.historyPay

      if (price !== 0) {
        if (payHistory.find(x => x.ExamID === id)) {
          this.checkExamState(id, price, min, timeEnd, examDate, startTime, examStartTime, examEndTime, examType)
        } else {
          this.showBuyExamDialog = true
        }
      } else {
        this.checkExamState(id, price, min, timeEnd, examDate, startTime, examStartTime, examEndTime, examType)
      }
    },
    seePastExamDetail(id, price) {
      this.examID = id
      let payHistory = this.historyPay
      if (price !== 0) {
        if (payHistory.find(x => x.ExamID === id)) {
          this.$router.push({path: 'ExamDetail', query: {ExamID: id, CanAnswer: 'false', currentExam: 'false'}})
        } else {
          this.showBuyExamDialog = true
        }
      } else {
        this.$router.push({path: 'ExamDetail', query: {ExamID: id, CanAnswer: 'false', currentExam: 'false'}})
      }
    },
    getExamsRecord() {
      let myHeaders = new Headers();
      myHeaders.append("Authorization", _this.$getUserData().token);
      let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "ExamManagement/HistoryExam", requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)
            if (json.length > 0) {
              _this.hasRecordExams = true
              _this.examsRecord = json
            } else {
              _this.hasRecordExams = false
            }

          })
          .catch(error => console.log('error', error));
    },
    buyExam() {
      this.showBuyExamDialog = false
      let myHeaders = new Headers();
      myHeaders.append("Authorization", _this.$getUserData().token);
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();
      urlencoded.append("ExamID", this.examID);

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };
//todo buy
      fetch(this.$baseUrl + "ExamManagement/BuyOnlineByPass", requestOptions)
          .then(response => response.text())
          .then(result => {
            _this.showResultDialog = true;
            _this.dialogResult = result;
            _this.getPayHistory()
          })
          .catch(error => console.log('error', error));
    },
    goToExam() {
      this.$setExamData(this.examID, this.endExamTime)
      this.$router.push({path: 'ExamDetail', query: {ExamID: this.examID, CanAnswer: 'true', currentExam: 'true'}})
    },
    getPayHistory() {
      let myHeaders = new Headers();
      myHeaders.append("Authorization", _this.$getUserData().token);

      let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "ExamManagement/ListPay", requestOptions)
          .then(response => response.text())
          .then(result => {
            _this.historyPay = JSON.parse(result)
          })
          .catch(error => console.log('error', error));
    },
    showCurrentExams() {
      this.currentExams = true;
      this.examsRecords = false;
      this.pastExams = false;
    },
    showPastExams() {
      this.currentExams = false;
      this.examsRecords = false;
      this.pastExams = true;
    },
    showExamsRecords() {
      this.currentExams = false;
      this.examsRecords = true;
      this.pastExams = false;
    }

  }
}
</script>
